





















































































































































































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import LeftNavigationComponent from "../../Workspace/Components/LeftNavigation.vue";
import TechnicalReportSummary from "./Components/Summary.vue";
import ProjectImpact from "./Components/ProjectImapct.vue";
import PerformanceReport from './Components/PerformanceReport.vue';
import EsmsDocuments from './Components/EsmsDocuments.vue';
import IssuesReport from './Components/IssuesReporting.vue';
import ImpactReport from './Components/ImpactReporting.vue';
import OtherFinalReportSections from './Components/OtherFinalReportSections.vue';
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { AppConstants as _app } from '@/shared/app.constants';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import PermissionService from '@/services/permission.service';
import { Feedback, GrantData , TechnicalReportData } from "@/entities";
import TechDocs from './Components/TechDocs.vue';
import { Locales } from "@/i18n/locales";

const permissionService = new PermissionService();
const namespace: string = "technicalReport";

@Component ({
  components: {
      LeftNavigationComponent,
      ProjectImpact,
	  TechnicalReportSummary,
      PerformanceReport,
      EsmsDocuments,
      VJsonschemaForm,
      IssuesReport,
      ImpactReport,
      OtherFinalReportSections,
      ValidationMessageComponent,
      TechDocs
  }
})
export default class FinalTechnicalReportComponent extends Vue {

    @State(namespace) technicalReport!: TechnicalReportData;
    // @State('grant') grant!: GrantData;
    @State("feedback") feedback!: Feedback;
    @Action("getGrantInfo", { namespace }) getGrantData: any;
    @Action("getTechnicalReport", { namespace }) getReport: any;
    @Action("getGrant", { namespace: 'grant' }) getGrant: any;
    @Action("saveTechnicalReport", { namespace }) saveReport: any;
    @Action("saveFinalReport", { namespace }) saveReportData: any;
    @Action("saveFinalReportDirty", { namespace }) saveReportDirty: any;
    @Action("updateSelectedKey", { namespace }) setActiveKey: any;
    @Getter("technicalReportSections", { namespace }) finalTechnicalReportSections: any;
    @Action("uploadDocument", { namespace }) uploadDocument: any;
    @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number;
    @Getter('isStartingPeriod', {namespace: "technicalReport"}) startingPeriod: boolean;

    showSideBar = true;
    isDirty = false;
    datum: any = {};
    options: any = {};
    schemaformKey: number = 0;
    customComponents = ['impact', 'performance', 'summary', 'issues', 'impactReporting', 'techDocs'];
    actions = _app.actions;
    subjects = _app.subjects;
    enabledStatuses = [_app.techReportStatus.notStarted, _app.techReportStatus.inProgress, _app.techReportStatus.waitingLP];
    techReportpending = _app.techReportStatus.pendingReview;
    techReportStatus = _app.techReportStatus;
    ppoAccess:boolean = false;
    initiativeId:number = 0;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    enableButton() {
        const self = this;
        //@ts-ignore
        if(this.$can(this.actions.update, this.subjects.grantReports) &&
            (self.enabledStatuses.includes(this.technicalReport.selectedReport.WorkFlowStatusId)
            || (self.technicalReport.selectedReport.WorkflowInfo
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus))
        ) {
            // for applicants
            return true;
        }
        //@ts-ignore
        else if((this.$can(this.actions.fullaccess, this.subjects.all) || this.$can(this.actions.manage, this.subjects.program) || this.ppoAccess) &&
        (self.enabledStatuses.includes(this.technicalReport.selectedReport.WorkFlowStatusId)
            || (self.technicalReport.selectedReport.WorkflowInfo
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus))) {
            // show button for program admins and system admins
            return true;
        }
        //@ts-ignore
        // else if(this.$can(this.actions.read, this.subjects.grantReports) && self.technicalReport.selectedReport.WorkFlowStatusId === self.techReportpending)
        //     return true;
    }

    @Watch("initiativeId")
    ppoPermission(val: any) {
        if (val) {
            this.ppoHasPermission(val);
        } else {
            this.ppoAccess = false;
        }
    }

    ppoHasPermission(initiativeId) {
        // Get logged in user initiatives
        permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
            // get user initiaive
            this.ppoAccess = hasPermission;
        });
    }

    downloadPdf() {
        let transformedData = { ...this.transformData(), ...this.technicalReport.finalReport };

        let option = {
            "schema":this.subSections,
            "data":transformedData,
            "docTags" :this.technicalReport.documentTags,
            "user": this._username,
            "currency":this.technicalReport.grantInfo.BudgetCurrency,
            "id":this.technicalReport.grantInfo.ApplicationId,
            "type":"",
            "excludeKeys":["summary"],
            "isStartingPeriod": this.startingPeriod
        };
        this.$services.TechnicalReoprt.generate(option);
    }
    
    transformData() {
        let data = {};
        for(let key1 in this.grantData[0])
        {
            if(Array.isArray(this.grantData[0][key1])) {
                data[key1] = this.grantData[0][key1];
            } else {
                for(let key2 in this.grantData[0][key1])
                {
                    data[key2] = this.grantData[0][key1][key2];
                }
            }
        }
        data['monitoringPlan'] = this.technicalReport.impact;
        for (let key1 in this.technicalReport.grantInfo)
        {
            if(key1 != 'monitoringPlan') {
                data[key1] = this.technicalReport.grantInfo[key1];
            }
        }
        data['reportingPeriod'] = this.technicalReport.selectedReport.Title;

        return data
    }

    get formOptions() {
        return {
            "uploadAction": this.uploadDocument,
            "removeAction": this.$services.document.removeDocument,
            "downloadAction": this.$services.document.download,
            "locale": this.defaultLocale,
            "ApplicationId": this.technicalReport.selectedReport.TechnicalReportId,
            "baseURI": process.env.VUE_APP_API_Base_URL,
            //@ts-ignore
            "rights": this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
            "entity": _app.entities.techReport,
            "feedbacks": this.feedback.feedbackHeaders,
            "transactionId": this.technicalReport.selectedReport.TechnicalReportId,
            "user": this._userid,
            "fileSizeLimit": this.appSettings.MaxFileSizeLimit,
            "actions": {
                createHeader: this.createFeedbackHeader,
                list: this.getFeedbacks,
                resolveFeedback: this.resolveFeedback,
                reopenFeedback: this.reopenFeedback,
                updateFeedback: this.$services.comment.Update
            },
            //@ts-ignore
            disableAll: this.$can(this.actions.update, this.subjects.grantReports) && [this.techReportStatus.pendingReview, this.techReportStatus.readyForValidation, this.techReportStatus.approved, this.techReportStatus.terminated].includes(this.technicalReport.selectedReport.WorkFlowStatusId) && this.technicalReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus !== 1 ? true: false
        };
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    topmenuChanged(key) {
        this.saveDirty(() => {
            this.setActiveKey(key);
            window.location.hash = `#${key}`;
        });
    }

    /** set is-dirty flag  */
    setDirtyFlag(flag: boolean) {
        this.isDirty = flag;
    }

    back() {
        let grantId = this.technicalReport.selectedReport.GrantId.toString();
        this.$router.push({
            name: "grantSummary",
            params: { grantId: grantId }
        });
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.saveDirty(() => {
            this.technicalReport.selectedKey = key;
            this.schemaformKey += 1;
            window.location.hash = `#${this.technicalReport.selectedKey}`;
        });
    }

    /** input event */
    showInput(e) {
        this.$emit("input", true);
    }

    /** error event */
    showError(err) {
        window.alert(err);
    }

    /** change event */
    showChange(e) {
        this.$emit("input", true);
    }

    /*** save if form is dirty */
    saveDirty(callback: any) {
        const self = this;

        if(this.isDirty && this.enableButton()) {
            // save the data if form is dirty
            this.setDirtyFlag(false);
            let datum = self.$services.monitor.copyPerformanceReportData(self.technicalReport.grantData);
            this.saveReportDirty({
                data: { data: datum, impactReport: self.technicalReport.impact, finalReportData: self.technicalReport.finalReport },
                grantId: self.technicalReport.selectedReport.GrantId,
                reportId: self.technicalReport.selectedReport.TechnicalReportId,
                context: 'save'
            })
            .then(() => {
                callback();
            });
        } else {
            callback();
        }  
    }

    saveData() {
        const self = this;
        let datum = self.$services.monitor.copyPerformanceReportData(self.technicalReport.grantData);
        this.saveReportData({
            data: { data: datum, impactReport: self.technicalReport.impact, finalReportData: self.technicalReport.finalReport },
            grantId: self.technicalReport.selectedReport.GrantId,
            reportId: self.technicalReport.selectedReport.TechnicalReportId
        }).then(() => {
            this.setDirtyFlag(false);
        });
    }

    /** pre validation action */
    preValidation() {
        return this.saveReportData({
            data: { data: this.technicalReport.grantData, impactReport: this.technicalReport.impact, finalReportData: this.technicalReport.finalReport },
            grantId: this.technicalReport.selectedReport.GrantId,
            reportId: this.technicalReport.selectedReport.TechnicalReportId,
            context: 'submit'
        });
    }

    /** show validations */
    showValidation(msgs: any) {
        this.technicalReport.validationMessages = msgs;
        this.technicalReport.showValidationDilog = true;
    }

    validationMessageClicked() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
    }

    validationMessageClosed() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
    }

    updateStatus(item) {
        this.technicalReport.selectedReport.WorkFlowStatusId = item.StepId;
        this.technicalReport.selectedReport.Comments = item.Comments;
        this.technicalReport.selectedReport.Subject = item.Subject;
        this.technicalReport.selectedReport.notify = item.notify;
        this.saveReport({
            data: this.technicalReport.selectedReport,
            id: this.technicalReport.selectedReport.TechnicalReportId
        }).then(() => { 
            this.$router.push({
                name: "grantSummary",
                params: { grantId: this.technicalReport.selectedReport.GrantId.toString() }
            });        
        });
    }

    fileChanged(e)
    {
        //@ts-ignore
        if(this.enableButton())
        {
            this.saveData()
        }

    }

    feedbackInfo() {
        setTimeout(() => {
            this.getFeedbackInfo({ entity: _app.entities.techReport, transactionId: this.technicalReport.selectedReport.TechnicalReportId });
        }, 1000)
    }

    /** computed property workflow items */
    get workFlowItems() {
        return this.technicalReport.selectedReport.WorkflowInfo || {}
    }

    get subSections() {
        return this.finalTechnicalReportSections || {};
    }
    
    /** get child schema properties to populate the left panel*/
    get subSchema(): any {
        if(this.subSections && this.subSections.properties) {
            let schema = this.subSections.properties[this.technicalReport.selectedKey] || {};
            schema['x-virtual'] = false;
            return schema;
        }
    }

    get grantData() {
        const self = this;
        return self.technicalReport.grantData.techReport.filter(x => x.reportId === self.technicalReport.selectedReport.TechnicalReportId);
    }

    get dataModel() {
        const self = this;
        return self.technicalReport.grantData.techReport.find(x => x.reportId === self.technicalReport.selectedReport.TechnicalReportId);
    }


    /** watch method to refresh page on page load */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
      if(changedRoute && changedRoute.name === 'finalTechnicalReport') {
          const reportId = changedRoute.params.technicalReportId;

           if(this.$route.hash)
                this.technicalReport.selectedKey = this.$route.hash.substr(1);
            else
                window.location.hash = `#${this.technicalReport.selectedKey}`;

            // Added this condition to hadle the route change on hash value update
            if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.technicalReportId !== previousRoute.params.technicalReportId ) {

                this.getReport(reportId).then(resp => {
                    this.getGrant(resp.GrantId);
                    this.getGrantData(resp.GrantId).then((resp) => {
                        this.initiativeId = resp.meta.InitiativeId;
                    });;
                });
                this.getFeedbackInfo({ entity: _app.entities.techReport, transactionId: reportId });
            }
      }
  }

}
